export class CompanyProviders {
    active = false;
    list;
    constructor(providers) {
        if (!providers) {
            return;
        }
        this.active = providers.isActive ?? false;
        if (!this.active) {
            return;
        }
        this.list = providers.list;
    }
}
